import { StyleFunctionProps, defineStyleConfig } from '@chakra-ui/react'

const Select = defineStyleConfig({
  sizes: {
    md: {
      field: {
        h: "78px",
        py: "20px",
        fontSize: "16px",
        lineHeight: "28px",
      }
    }
  },
  variants: {
    primary: (props: StyleFunctionProps) => ({
      cursor: "pointer",
      field: {
        bg: props.colorMode === "light" ? "white" : "alphaWhite01",
        outline: "none",
        border: "1px",
        borderColor: props.colorMode === "light" ? "border" : "transparent",
        color: props.colorMode === "light" ? "navy" : "white",
        cursor: "pointer",
        _placeholder: {
          color: props.colorMode === "light" ? "navy" : "white",
        }
      },
      icon: {
        right: "20px"
      }
    })
  },
  defaultProps: {
    size: "md",
    variant: "primary"
  }
})
export default Select